import { Menu, Users, FileInput, BarChart3, Link2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Separator } from "@/components/ui/separator";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/", label: "Users", icon: Users },
  { to: "/bulk-import", label: "Bulk Import", icon: FileInput },
  { to: "/stats", label: "Statistics", icon: BarChart3 },
  { to: "/profiles", label: "Profiles", icon: Link2 },
];

interface MobileNavProps {
  username?: string;
  onLogout: () => void;
}

export function MobileNav({ username, onLogout }: MobileNavProps) {
  const location = useLocation();

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden" aria-label="Open menu">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[260px] p-0">
        <SheetHeader className="p-4 text-left">
          <SheetTitle className="text-lg font-semibold">Nexus</SheetTitle>
          {username && <p className="text-sm text-muted-foreground">{username}</p>}
        </SheetHeader>
        <Separator />
        <nav className="flex flex-col gap-1 p-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={cn(
                  "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                  active
                    ? "bg-primary text-primary-foreground"
                    : "text-foreground hover:bg-muted"
                )}
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </Link>
            );
          })}
          <Separator className="my-2" />
          <button
            onClick={onLogout}
            className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-destructive transition-colors hover:bg-destructive/10"
          >
            <LogOut className="h-4 w-4" />
            Log out
          </button>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
